<div *ngIf="params.data && !params.data.editable">
    {{params.data[params.colDef.field]}}
</div>
<div *ngIf="params.data && params.data.editable">
    <input type="number" [(ngModel)]="displayNumberValue" min="0" (keypress)="preventNonDigits($event)"
    (paste)="sanitizePaste($event)" (ngModelChange)="onNumberValueInput($event)" style="width:100%;">
</div>